import React from 'react'
import { useFormatMessage } from '@babylon/intl'
import { LinkAnchor } from '@babylon/medkit'
import { trackTealiumEvent } from '@/tracking'
import { useTrackingScreenTitle } from '@/hooks'

import messages from './messages'
import styles from './Footer.module.scss'

export interface LinkType {
  key: keyof typeof messages
  link: string
}

interface Props {
  links?: LinkType[]
}

interface TrackingProps {
  href: string
  label: string
  screenTitle: string
}

const onLinkClick = ({ href, label, screenTitle }: TrackingProps) => {
  trackTealiumEvent({
    eventAction: 'clicked footer link',
    eventCategory: 'signup',
    eventLabel: label,
    destination: href,
    screen_title: screenTitle,
    tealium_event: 'clicked footer link',
  })
}

const Footer = ({ links }: Props) => {
  const translate = useFormatMessage()
  const year = new Date().getFullYear()
  const stepTrackingName = useTrackingScreenTitle()

  return (
    <footer className={styles.footer} data-testid="Footer">
      {links && links.length && (
        <nav className={styles.footerNavigation} data-testid="footerNavigation">
          {links.map((link) => (
            <LinkAnchor
              key={link.key}
              href={link.link}
              className={styles.footerNavigationItem}
              data-testid={`footerLink-${link.key}`}
              onClick={() =>
                onLinkClick({
                  href: link.link,
                  label: link.key,
                  screenTitle: stepTrackingName,
                })
              }
            >
              {translate(messages[link.key])}
            </LinkAnchor>
          ))}
        </nav>
      )}
      <p className={styles.copyright}>
        &copy; Babylon {year}. {translate(messages.allRightsReserved)}
      </p>
    </footer>
  )
}

export default Footer
